import { render, staticRenderFns } from "./OddsChlog.vue?vue&type=template&id=5253f674&"
import script from "./OddsChlog.vue?vue&type=script&lang=js&"
export * from "./OddsChlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports